import instadrink_pro from "../assets/instadrink_pro.png";
import instadrink_client from "../assets/instadrink_client.png";
import instadrink_pwa from "../assets/instadrink_pwa.png";
import instadrink_admin from "../assets/instadrink_admin.png";
import instadrink_network from "../assets/instadrink_network.png";
import tjwaal from "../assets/tjwaal.png";

export const portfolioData = [
  {
    id: 1,
    image: instadrink_pro,
    title: "Instadrink Pro - Event, Venue & Restaurant Management",
    subtitle:
      "A mobile platform for event organizers, restaurants, and music studios to manage staff, tickets, payments, and guest experiences in real time.",
    playStore: "https://play.google.com/store/apps/details?id=com.food.instadrinkpro&hl=fr",
    appStore: "https://apps.apple.com/us/app/instadrink-pro/id6443986381",
    link: null,
    technologies: [
      "React Native",
      "Expo",
      "Firebase & Firestore",
      "React Navigation",
      "Redux",
      "Reanimated",
      "Moti",
      "Algolia",
      "i18next",
      "Sentry",
    ],
    platforms: ["iOS", "Android"],
    description:
      "Instadrink Pro is the ultimate mobile platform within the Instadrink ecosystem, designed specifically for venue owners, event organizers, and studio managers. Packed with countless features, it helps businesses manage every aspect of their operations—whether it’s running a restaurant, coordinating events, or handling bookings for a musical studio. With Instadrink Pro, staff can efficiently scan tickets, manage table reservations, and process orders step by step, ensuring smooth operations from start to finish. The platform supports multiple user roles, giving owners, waiters, bouncers, DJs, and ambassadors dedicated workflows that streamline day-to-day management. All operations—from event scheduling and ticket validation to payments and referral programs—are centralized in one powerful app, making it easy to run complex operations with confidence.",
    contribution: [
      "Led frontend architecture and development of the React Native app using Expo, transforming product ideas into fully implemented features",
      "Designed and implemented role-based navigation and access control for multiple user types (owners, staff, organizers)",
      "Built and maintained core application flows including ticket validation, QR code scanning, and operational workflows",
      "Integrated Firebase Authentication and Firestore with real-time listeners to support live data updates",
      "Architected and implemented the push notification system for operational and event-related alerts",
      "Contributed to backend improvements by fixing bugs, optimizing queries, and enhancing existing APIs",
      "Improved application performance, state management, and overall UX consistency",
      "Established a reusable component architecture to ensure UI consistency and scalability",
    ],
  },

  {
    id: 2,
    image: instadrink_admin,
    title: "ID Network Admin – Enterprise Venue Management Platform",
    subtitle:
      "A production-ready SaaS admin dashboard for managing venues, events, staff, bookings, subscriptions, and restaurant operations across multiple locations.",
    playStore: null,
    appStore: null,
    link: "https://eventshom.web.app/",
    technologies: [
      "React",
      "TypeScript",
      "Redux",
      "Material UI (MUI v5)",
      "Firebase & Firestore",
      "Auth0 (SSO & RBAC)",
      "Stripe Subscriptions & Payments",
      "Cloud Functions",
      "ApexCharts",
      "FullCalendar",
      "Framer Motion",
      "i18next (Internationalization)",
      "Progressive Web App (PWA)",
    ],
    platforms: ["Web"],
    description:
      "ID Network Admin is a large-scale, enterprise-grade SaaS platform that enables venue owners, restaurant operators, and event organizers to manage their entire business ecosystem from a single dashboard. The platform supports multi-organization and multi-location management, advanced booking and reservation workflows, staff scheduling, restaurant and F&B operations, subscription billing, analytics, and customer communication. Built with React and TypeScript, it integrates Stripe for recurring subscriptions, Auth0 for secure authentication, Firebase for real-time data, and delivers a responsive, PWA-enabled experience across desktop, tablet, and mobile.",
    contribution: [
      "Developed and maintained a large-scale React + TypeScript admin dashboard with 50+ pages",
      "Implemented multi-organization and multi-venue architecture with independent configurations",
      "Built advanced event, booking, and reservation management workflows with approval states",
      "Developed staff scheduling and availability management using calendar-based interfaces",
      // "Implemented restaurant and F&B management including menus, products, tables, and orders",
      "Integrated Stripe for subscriptions, recurring billing, platform fees, and payment webhooks",
      "Implemented role-based access control (RBAC) with permission guards",
      "Built analytics dashboards with real-time KPIs and ApexCharts visualizations",
      "Implemented notifications, and customer communication tools",
      // "Contributed to PWA support, performance optimizations, and responsive design",
    ],
  },

  {
    id: 3,
    image: instadrink_pwa,
    title: "InstaDrink PWA – Instant Event & Food Ordering",
    subtitle:
      "A high-performance Progressive Web App (PWA) that enables instant ticket purchasing and food ordering directly from the browser, with anonymous user support and no app download required.",
    playStore: null,
    appStore: null,
    link: "https://instadrinkpwa.web.app",
    technologies: [
      "React",
      "React Native",
      "Expo",
      "Progressive Web App (PWA)",
      "Firebase",
      "Redux",
      "Stripe Payments",
      "Google Maps API",
      "Seatsio (Seat Selection)",
      "Service Workers",
      "i18next",
      "Native Base",
      "React Native Paper",
    ],
    platforms: ["Web"],
    description:
      "InstaDrink PWA is a web-based Progressive Web App designed to drastically reduce friction in event ticket purchasing and food ordering. Unlike traditional mobile apps, it allows users to place orders and buy tickets instantly from any browser without downloading an app or creating an account, thanks to anonymous user support. The platform provides fast checkout, secure Stripe payments, real-time order tracking, QR and barcode-based digital tickets, seat selection for events, push notifications and full multi-language support. Optimized for speed and conversion, the app delivers a seamless experience across mobile browsers.",
    contribution: [
      "Designed and developed a web-first Progressive Web App focused on speed and conversion",
      "Implemented anonymous user authentication to enable ordering without signup",
      "Built instant food ordering and ticket purchasing flows with minimal user friction",
      "Integrated Stripe for fast and secure web-based checkout",
      "Implemented event ticketing with Seatsio seat selection and digital QR/barcode tickets",
      "Developed real-time order tracking and order history features",
      "Implemented multi-language support with dynamic language switching using i18next",
      "Optimized UI for mobile browsers",
    ],
  },

  {
    id: 4,
    image: instadrink_network,
    title: "InstadrinkWeb – Event Ticketing & Studio Booking Platform",
    subtitle:
      "A full-stack, enterprise-grade booking platform combining advanced event ticketing, professional studio reservations, AI-powered automation, and white-label deployments for organizers, studios, and venues.",
    playStore: null,
    appStore: null,
    link: "https://instadrinkweb-ewqf-3ae8q25lw-aggounixs-projects.vercel.app/",
    technologies: [
      "Next.js 14",
      "React 18",
      "TypeScript",
      "Tailwind CSS",
      "Zustand",
      "Redux Toolkit & Redux Persist",
      "Firebase & Firestore",
      "Firebase Cloud Functions",
      "Stripe Payments & PaymentIntents",
      "KKiapay",
      "OpenAI GPT-3.5",
      "Anthropic Claude",
      "Google Maps API",
      "Spotify API",
      "Seats.io",
      "Radix UI",
      "Framer Motion",
      "Konva.js",
      "i18next (Internationalization)",
      "Progressive Web App (PWA)",
      "Docker",
    ],
    platforms: ["Web"],
    description:
      "InstadrinkWeb is an enterprise-scale SaaS platform designed for event organizers, studios, and venue operators to manage complex ticketing and booking workflows from a single system. The platform supports multi-vendor environments, dynamic ticket pricing, studio and resource scheduling, flexible payment modes (full, deposit, hold, manual), AI-powered conversational booking, referral and sharing systems, and deep analytics. Built with Next.js and TypeScript on a serverless Firebase architecture, InstadrinkWeb is production-ready, white-label capable, and optimized for scalability, performance, and international markets.",
    contribution: [
      "Maintained and ensured smooth operation of event ticketing workflows",
      "Monitored and corrected bugs across the platform to ensure reliability and fast user experience",
      "Maintained studio room booking features, including conflict detection and scheduling",
      "Ensured stable integration with Stripe payments and Firebase services",
      "Contributed to cross-browser responsiveness and PWA behaviors",
      "Supported multi-language functionality and dynamic language switching",
    ],
  },

  {
    id: 5,
    image: instadrink_client,
    title: "InstaDrink mobile – Event & Food Discovery",
    subtitle:
      "A mobile application for discovering events, restaurants, food delivery, DJ experiences, and trading event tickets via a built-in marketplace.",
    playStore: null,
    appStore: null,
    link: null,
    technologies: [
      "React Native",
      "Expo",
      "Firebase & Firestore",
      "React Navigation",
      "Redux",
      "Axios",
      "Stripe Payments",
      "Algolia Search",
      "i18next",
      "Lottie Animations",
    ],
    platforms: ["iOS", "Android"],
    description:
      "InstaDrink mobile is a modern social discovery platform that enables users to explore events, restaurants, food delivery services, and DJ experiences from a single application. In addition to standard ticket booking, the app includes a dedicated ticket resale marketplace where users can securely resell and purchase already purchased tickets. The platform supports QR-based digital tickets, real-time order tracking for food, DJ discovery with playlists and events, venue browsing, advanced search, and multi-language support, delivering a seamless experience across iOS and Android.",
    contribution: [
      "Developed cross-platform features using React Native and Expo",
      "Implemented event discovery, ticket booking, and QR-based digital tickets",
      "Built and integrated the ticket resale marketplace for peer-to-peer ticket trading",
      "Worked on restaurant browsing, smart cart, and food ordering flows",
      "Integrated Stripe for secure payments and transaction handling",
      "Implemented Firebase Authentication and Firestore data models",
      "Added Algolia-powered search for events and restaurants",
      "Contributed to multi-language support using i18next",
    ],
  },

  {
    id: 6,
    image: tjwaal,
    title: "Tjwaal – Multi-Service Travel Booking Platform",
    subtitle:
      "A production-ready React Native travel booking platform enabling users to search, book, and manage flights, hotels, offers, and ancillary travel services with real-time pricing and secure payments.",
    playStore: "https://play.google.com/store/apps/details?id=com.tjwaal&hl=en",
    appStore: "https://apps.apple.com/us/app/tjwaal-hotels-flights/id6741045428",
    link: null,
    technologies: [
      "React Native",
      "TypeScript",
      "Redux Toolkit",
      "RTK Query",
      "Axios",
      "React Navigation",
      "React Native Reanimated",
      "Lottie Animations",
      "MMKV Encrypted Storage",
      "Formik & Yup",
      "i18next",
      "React Native Maps",
    ],
    platforms: ["iOS", "Android"],
    description:
      "Tjwaal is an enterprise-grade, multi-service travel booking platform built with React Native for iOS and Android. The app enables travelers to discover and book flights, hotels, and travel offers while supporting complex workflows such as multi-leg itineraries, multi-passenger management, and multi-room hotel bookings. It integrates real-time search and pricing APIs, secure payment gateways with 3D Secure authentication, multilingual support (English and Arabic with RTL), and robust user profile management. Designed for scalability across MENA and international markets, Tjwaal delivers a polished, secure, and highly optimized mobile booking experience.",
    contribution: [
      "Developed a large-scale React Native application supporting flights, hotels, offers, and travel services",
      "Implemented complex flight booking flows including multi-city itineraries, passenger validation, and real-time pricing",
      // "Integrated HyperPay and OPPWAMobile with 3D Secure authentication and Apple Pay support",
      "Implemented secure authentication, token refresh, and encrypted local storage using MMKV",
      "Designed multilingual UI with full English/Arabic support including RTL/LTR layout handling",
      "Built advanced state management using Redux Toolkit, RTK Query, and Redux Persist",
      "Developed reusable UI components, animated transitions, and bottom-sheet driven interactions",
      "Handled edge cases such as payment success with booking failure, retries, and async search flows",
      "Optimized performance, API caching, and mobile UX for production-scale deployment",
    ],
  },
];
